import React, { useEffect, useState } from 'react'
import {
    Box,
    Button,
    FormControlLabel,
    Switch,
    Table,
    TableBody,
    TableCell as MuiTableCell,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
    useTheme,
    IconButton,
    Tooltip
} from '@mui/material'
import { CustomModal } from '../components/Modal';
import { Home, Refresh, LockReset } from '@mui/icons-material';
import { useInmuebles } from '../hooks/useInmuebles';
import { IInmueble } from '../models/inmuebles';
import { TableHeaderCell } from '../components/Table/TableHeaderCell';
import { styled } from '@mui/material/styles';
import { ConfirmAndChild } from '../components/ConfirmWithChilds';

// Celda compacta
const CompactTableCell = styled(MuiTableCell)(({ theme }) => ({
    padding: theme.spacing(1),
    '&:first-of-type': {
        paddingLeft: theme.spacing(1)
    },
    '&:last-of-type': {
        paddingRight: theme.spacing(1)
    }
}));

export const ControlInmuebles = () => {
    const { getInmuebles, setActivacionInactivacion, resetPassword } = useInmuebles()
    const [inmueblesList, setInmueblesList] = useState<IInmueble[]>([])
    const [openModal, setOpenModal] = useState(false)
    const [modalMessage, setModalMessage] = useState('')

    const [itemSelect, setItemSelect] = useState<IInmueble>({} as IInmueble)
    const [confirm, setConfirm] = useState<boolean>(false)

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const handleOpen = () => setOpenModal(true);
    const handleClose = () => setOpenModal(false);

    const handleActivarDesactivar = async (idCasa: number) => {
        let res = await setActivacionInactivacion(idCasa)
        if (res) {
            setModalMessage(res.message)
            setInmueblesList(inmueblesList.map(inmueble =>
                inmueble.casa === idCasa ? { ...inmueble, estado: inmueble.estado === 0 ? 1 : 0 } : inmueble
            ))
        } else {
            setModalMessage('Error al activar/desactivar el inmueble')
        }
        handleOpen()
    }

    const handleRecuperarPassword = async (idCasa: number, numCasa: string) => {
        let res = await resetPassword(idCasa, numCasa)
        if (res) {
            setModalMessage("El nuevo password es: " + res.message)
        } else {
            setModalMessage('Error al generar nuevo password')
        }
        handleOpen()
    }

    useEffect(() => {
        (async () => {
            let res = await getInmuebles()
            if (res) {
                setInmueblesList(res)
            } else {
                setModalMessage('Error al obtener el listado de inmuebles')
                handleOpen()
            }
        })()
    }, [])

    return (
        <>
            <ConfirmAndChild
                message={
                    <center>
                        <Typography variant="body1">¿Esta seguro que desea cambiar la contraseña?</Typography>
                        <br />
                        <Typography variant="body1">Casa seleccionada:</Typography>
                        <Box>
                            <h1>{itemSelect.num_casa}</h1>

                        </Box>
                    </center>
                }
                okText='Cambiar'
                okAction={() => handleRecuperarPassword(itemSelect.casa, itemSelect.num_casa)}
                show={confirm}
                setShow={setConfirm}
            />
            <Box textAlign="center" display="flex" alignItems="center" flexDirection='column' p={1}>
                <Typography variant="h5" component="div" gutterBottom marginY='0.5em'>
                    Inmuebles
                </Typography>

                <Box width="100%" overflow="auto">
                    <Table size="small" stickyHeader sx={{ minWidth: isSmallScreen ? 400 : '100%' }}>
                        <TableHead>
                            <TableRow>
                                <TableHeaderCell width="15%">Casa</TableHeaderCell>
                                <TableHeaderCell width={isSmallScreen ? "25%" : "35%"}>Nombre</TableHeaderCell>
                                <TableHeaderCell width={isSmallScreen ? "25%" : "35%"}>PSW</TableHeaderCell>
                                <TableHeaderCell width="20%">Estado</TableHeaderCell>
                                <TableHeaderCell width="30%">Acción</TableHeaderCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {inmueblesList.length > 0 && inmueblesList.map((inmueble, index) => (
                                <TableRow key={index}>
                                    <CompactTableCell>{inmueble.num_casa}</CompactTableCell>
                                    <CompactTableCell>
                                        <Typography noWrap sx={{ maxWidth: isSmallScreen ? '100px' : '120px' }}>
                                            {inmueble.nombre}
                                        </Typography>
                                    </CompactTableCell>
                                    <CompactTableCell>
                                        <Typography noWrap sx={{ maxWidth: isSmallScreen ? '100px' : '200px' }}>
                                            {inmueble.passw}
                                        </Typography>
                                    </CompactTableCell>
                                    <CompactTableCell>
                                        {isSmallScreen ? (
                                            <Tooltip title={inmueble.estado === 0 ? 'Inactivo' : 'Activo'}>
                                                <Switch
                                                    color="primary"
                                                    checked={inmueble.estado === 1}
                                                    onChange={() => handleActivarDesactivar(inmueble.casa)}
                                                    size="small"
                                                />
                                            </Tooltip>
                                        ) : (
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        color="primary"
                                                        checked={inmueble.estado === 1}
                                                        onChange={() => { setItemSelect(inmueble); setConfirm(true); }}
                                                        size="small"
                                                    />
                                                }
                                                label={inmueble.estado === 0 ? 'Inactivo' : 'Activo'}
                                                labelPlacement="start"
                                            />
                                        )}
                                    </CompactTableCell>
                                    <CompactTableCell>
                                        {isSmallScreen ? (
                                            <Tooltip title="Generar nuevo password">
                                                <IconButton
                                                    color="warning"
                                                    size="small"
                                                    onClick={() => { setItemSelect(inmueble); setConfirm(true); }}
                                                >
                                                    <LockReset fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        ) : (
                                            <Button
                                                color="warning"
                                                size="small"
                                                variant="outlined"
                                                onClick={() => { setItemSelect(inmueble); setConfirm(true); }}
                                                startIcon={<LockReset />}
                                                fullWidth
                                            >
                                               
                                            </Button>
                                        )}
                                    </CompactTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>

                <CustomModal
                    openState={openModal}
                    onCloseHandler={handleClose}
                >
                    <Typography variant="h6" component="div" gutterBottom>
                        {modalMessage}
                    </Typography>
                    <Button
                        color="secondary"
                        variant="outlined"
                        sx={{ marginY: 2, width: '50%' }}
                        onClick={handleClose}
                        size="small"
                    >
                        OK
                    </Button>
                </CustomModal>
            </Box>
        </>
    )
}